import { antiForgeryPost } from "../../utils/fetch";

export function addHKEventListeners() {
    addQuizLaunchListeners();

    ['hk-recommendation-redirect', 'hk-survey-completed'].forEach(event => {
        document.body.addEventListener(event, e => tagHKCustomer(e));
    });
}

function addQuizLaunchListeners() {
    const elements = Array.from(document.querySelectorAll('.hk-external-entry-point,[href*="#hk-entry-widget-open"]'));

    elements.forEach(element => element.style.pointerEvents = 'none');

    function attachHkEntryPointEvents() {
        const hkEntryWidget = document.getElementById('hk-entry-widget');

        if (hkEntryWidget) {
            elements.forEach(element => {
                const elementIdentifier = element.id || element.text || element.innerHTML;
                element.addEventListener('click', (e) => {
                    e.preventDefault();
                    hkEntryWidget?.dispatchEvent(new CustomEvent('hk-entry-widget-open', { detail: elementIdentifier }));
                });
                element.style.pointerEvents = 'auto';
            });
        } else {
            setTimeout(attachHkEntryPointEvents, 1000);
        }
    }
    attachHkEntryPointEvents();
}

function tagHKCustomer() {
    const hk = JSON.parse(localStorage.getItem('humankind'));

    if (!hk?.customerId) {
        return;
    }

    antiForgeryPost('/api/user/AddHumankindId', {
        method: 'PUT',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ hkid: hk.customerId })
    });
}